import {
  GET_MESSAGE_SEGMENTS_REQ,
  GET_MESSAGE_SEGMENTS_SUCCESS,
  GET_MESSAGE_SEGMENTS_FAIL,
  GET_OVERALL_MESSAGE_SEGMENTS_SUCCESS,
  GET_OVERALL_MESSAGE_SEGMENTS_FAIL,
  CREATE_MESSAGE_SEGMENT_REQ,
  CREATE_MESSAGE_SEGMENT_SUCCESS,
  CREATE_MESSAGE_SEGMENT_FAIL,
  CREATE_MESSAGE_SEGMENT_RESET,
  UPDATE_MESSAGE_SEGMENT_REQ,
  UPDATE_MESSAGE_SEGMENT_SUCCESS,
  UPDATE_MESSAGE_SEGMENT_FAIL,
  UPDATE_MESSAGE_SEGMENT_RESET,
  DELETE_MESSAGE_SEGMENT_REQ,
  DELETE_MESSAGE_SEGMENT_SUCCESS,
  DELETE_MESSAGE_SEGMENT_FAIL,
} from "../constants/messageSegments";

export const messageSegmentReducer = (
  state = { messageSegments: [], skip: 0, limit: 10, totalPage: 0 },
  action
) => {
  switch (action.type) {
    case GET_MESSAGE_SEGMENTS_REQ:
      return { loading: true };
    case GET_MESSAGE_SEGMENTS_SUCCESS:
      // console.log("payload", action.payload);
      return {
        loading: false,
        messageSegments: action.payload?.body?.messageSegmentsList || [],
        totalPage:
          action.payload?.body?.count % action.payload?.limit === 0
            ? action.payload?.body?.count / action.payload?.limit
            : parseInt(action.payload.body?.count / action.payload?.limit) + 1,
      };
    case GET_MESSAGE_SEGMENTS_FAIL:
      return { loading: false, error: action.payload };
    case GET_OVERALL_MESSAGE_SEGMENTS_SUCCESS:
      return { ...state, loading: false, allMessageSegments: action.payload };
    case GET_OVERALL_MESSAGE_SEGMENTS_FAIL:
      return { ...state, loading: false, error: action.payload };
    case CREATE_MESSAGE_SEGMENT_REQ:
      return { ...state, loading: true };
    case CREATE_MESSAGE_SEGMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        successCreate: true,
        // automationCreate: action.payload?.automations,
        messageSegmentCreate: action.payload,
        messageSegments: [...state.messageSegments, action.payload].sort(
          function (a, b) {
            return new Date(b.createdAt) - new Date(a.createdAt);
          }
        ),
      };
    case CREATE_MESSAGE_SEGMENT_FAIL:
      return { ...state, loading: false, error: action.payload };
    case CREATE_MESSAGE_SEGMENT_RESET:
      return { ...state, loading: false, successCreate: false };
    case UPDATE_MESSAGE_SEGMENT_REQ:
      return { ...state, loading: true };
    case UPDATE_MESSAGE_SEGMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        successUpdate: true,
        messageSegments: state.messageSegments.map((segment) =>
          segment._id === action.payload._id ? action.payload : segment
        ),
      };
    case UPDATE_MESSAGE_SEGMENT_RESET:
      return { ...state, loading: false, successUpdate: false };
    case UPDATE_MESSAGE_SEGMENT_FAIL:
      return { ...state, loading: false, error: action.payload };
    case DELETE_MESSAGE_SEGMENT_REQ:
      return { ...state, loading: true };
    case DELETE_MESSAGE_SEGMENT_SUCCESS:
      return {
        loading: false,
        successDelete: true,
      };
    case DELETE_MESSAGE_SEGMENT_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
